import React from "react";
import { ChevronRight } from "lucide-react";
import { STEPS } from "./CampaignWizard.constants";

const WizardProgress = ({ currentStep }) => {
  return (
    <div className="wizard-progress">
      {STEPS.map((step, index) => (
        <div
          key={step.id}
          className={`progress-step ${index === currentStep ? "active" : ""} ${
            index < currentStep ? "completed" : ""
          }`}
        >
          <div className="step-number">{index < currentStep ? "✓" : index + 1}</div>
          <span className="step-label">{step.label}</span>
          {index < STEPS.length - 1 && <ChevronRight size={16} className="step-separator" />}
        </div>
      ))}
    </div>
  );
};

export default WizardProgress;
